import { type IAgentActionModel, type IAgentActionSettings } from 'entities/AgentActions'
import { type ChatbotErrorsList } from 'entities/Chatbot'
import { type IAgentActionsErrorsAdapter } from 'widgets/AgentActions'

export const makeChatbotActionsErrorsAdapter = (
  list: ChatbotErrorsList<IAgentActionModel, IAgentActionSettings>
): IAgentActionsErrorsAdapter => ({
  getActionError: (action) => list.getError(action),
  removeActionError: (action) => list.removeError(action),
})
